export const FIELDS = {

  ID: 'id',
  BILL_PAYMENT_ID: 'billPaymentId',
  REFERENCE_ID: 'referenceId',
  TOTAL: 'total',
  BALANCE: 'balance',
  AMOUNT: 'amount',
  ACTIVE: 'active',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};
